import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { resolveRemoteUIMessage, useRemoteUICopy } from './copy.js';
import { useEffect, useRef, useState } from 'react';
import { MarkdownContent } from './MarkdownContent.js';
export function AgentCommandDetails({ command, resources, onRequestResource, onClose }) {
    const copy = useRemoteUICopy();
    const closeRef = useRef(null);
    useEffect(() => {
        const previous = document.activeElement;
        closeRef.current?.focus();
        return () => { if (previous instanceof HTMLElement && previous.isConnected)
            previous.focus({ preventScroll: true }); };
    }, []);
    const requestRef = useRef(onRequestResource);
    requestRef.current = onRequestResource;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const errorMessage = error ? resolveRemoteUIMessage(copy, error) : undefined;
    const [revision, retry] = useState(0);
    const binding = command.documentation;
    const resourceId = binding?.resourceId;
    useEffect(() => {
        let current = true;
        setError(undefined);
        if (!binding || !requestRef.current)
            return;
        setLoading(true);
        void Promise.resolve().then(() => requestRef.current(binding)).catch((reason) => {
            if (current)
                setError(reason instanceof Error ? { text: reason.message } : { key: 'documentationLoadFailed' });
        }).finally(() => { if (current)
            setLoading(false); });
        return () => { current = false; };
    }, [resourceId, revision]);
    const resource = resourceId ? resources[resourceId] : undefined;
    let markdown;
    if (resource?.status === 'available' && 'contentBase64' in resource && typeof resource.contentBase64 === 'string' && ['text/plain', 'text/markdown'].includes(resource.mediaType)) {
        try {
            markdown = new TextDecoder('utf-8', { fatal: true }).decode(Uint8Array.from(atob(resource.contentBase64), (character) => character.charCodeAt(0)))
                .replace(/^---\r?\n[\s\S]*?\r?\n---(?:\r?\n|$)/, '');
        }
        catch {
            markdown = undefined;
        }
    }
    return _jsxs("aside", { className: "agent-command-details", "aria-label": copy.commandDetails(command.kind), onKeyDown: (event) => { if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            onClose();
        } }, children: [_jsxs("header", { children: [_jsxs("div", { children: [_jsx("small", { children: copy.commandKind(command.kind) }), _jsx("h3", { children: command.name })] }), _jsx("button", { ref: closeRef, type: "button", "aria-label": copy.closeSkillDetails, onClick: onClose, children: "\u00D7" })] }), _jsxs("div", { className: "agent-command-details-content", children: [_jsx("p", { className: "agent-command-introduction", children: command.description }), loading ? _jsx("p", { role: "status", children: copy.loadingDocumentation })
                        : markdown !== undefined ? _jsx(MarkdownContent, { markdown: markdown })
                            : _jsx("p", { className: "agent-composer-note", children: errorMessage ?? (resource?.status === 'failed' ? resource.message
                                    : resource?.status === 'unavailable' ? resource.reason
                                        : !binding || !onRequestResource ? copy.descriptionOnly
                                            : copy.documentationUnavailable) }), !loading && binding && onRequestResource && markdown === undefined ? _jsx("button", { type: "button", onClick: () => retry((value) => value + 1), children: copy.retryDocumentation }) : null] })] });
}
//# sourceMappingURL=AgentCommandDetails.js.map